<template>
  <div class="chat-input-wrapper">
    <input
      v-model="message"
      @keydown.enter="sendMessage"
      type="text"
      class="chat-input"
      placeholder="Chat with your recommender"
    />
  </div>
</template>

<script>
export default {
  name: 'SendTextInput',
  data() {
    return {
      message: ''
    }
  },
  methods: {
    sendMessage() {
      if (this.message.trim() === '') {
        return
      }
      this.$emit('send', this.message)
      this.message = ''
    }
  }
}
</script>

<style scoped>
.chat-input-wrapper {
  position: fixed;
  bottom: 16px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 0 16px;
}

.chat-input {
  width: 100%;
  max-width: 640px;
  padding: 12px 24px;
  border: none;
  border-radius: 9999px;
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  background-color: #222;
  color: white;
  outline: none;
}

</style>
